/**
 * Created by tmorone on 2/8/2016.
 */

var $ = require('jquery');
var Marionette = require('backbone.marionette');
var App = require('./app.js');

var CollectionModel = require('./models/CollectionModel.js');
var LeaderboardModel = require('./models/LeaderboardModel.js');
var QuizModel = require('./models/QuizModel.js');

var FooterView = require('./views/FooterView.js');
var GamePageView = require('./views/GamePageView.js');
var LandingPageView = require('./views/LandingPageView.js');
var LeaderboardView = require('./views/LeaderboardView.js');
var QuizView = require('./views/QuizView.js');
var ServerDownView = require('./views/ServerDownView.js');

/**
 * The main controller that handles route requests.
 */
var Controller = Marionette.Object.extend({
    initialize: function() {
    },

    leaderboard : function(id) {
        new LeaderboardView({
            el: "#main",
            model: new CollectionModel({id:id}),
            collection: new LeaderboardModel(null, {id:id})
        });
        new FooterView({el:"#footer"}).render();
    },

    landing : function() {
        new LandingPageView({el: '#main', model: App.User}).render();
        new FooterView({el:"#footer"}).render();
    },

    offline : function() {
        new ServerDownView({el: '#main'}).render();
        new FooterView({el:"#footer"}).render();
    },

    game : function() {
        new GamePageView({el: '#main', model: App.User}).render();
    },

    game_pack : function(name) {
        PR.pack_name = name;
        new GamePageView({el: '#main', model: App.User}).render();

    },

    quiz : function(coll, kind) {
        new QuizView({
            el: "#main",
            model: new QuizModel({id:coll})
        });
        new FooterView({el:"#footer"}).render();
    }

});

/**
 * The application router. Maps end points to controller handlers.
 */
module.exports =  Marionette.AppRouter.extend({
    appRoutes: {
        '': 'game',
        'admin': 'game',
        'leaderboard/:id': 'leaderboard',
        'fbContent/feat/:id/:issue': 'game',
        'fbContent/wincard/:id/:kind_id': 'game',
        'fbContent/winjackpot/:prize/:currency': 'game',
        'quiz/:id': 'quiz',
        'quiz/:id/:kind': 'quiz',
        'pack/:name': 'game_pack',
        'offline': 'offline'
    },

    /**
     * Initialize our controller with the options passed into the application
     */
    initialize: function () {
        this.controller = new Controller({config: this.getOption('config')});
    }
});
